import React, { Component } from 'react';
import { Modal, withStyles, Fade, Backdrop } from '@material-ui/core';
import WallStepper from '../steps/wall';
import {connect} from 'react-redux';
import { IWall } from '../../core/models/wall';

const styles = (theme: any) => ({
    paper: {
        position: 'absolute' as any,
        width: 600,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 4)
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'auto'
    }
});

interface Props {
    classes:any;
    isOpen:boolean;
    toggler: () => void;
    editItemId: string | null;
    walls?:any;
}

interface State {
    editWall: IWall | null;
}

class ModalWall extends Component<Props, State> {
    state:State = {
        editWall: this.props.walls.find((wall:IWall) => wall._id === this.props.editItemId) || null
    }

    public render() {
        const  {classes, isOpen, toggler} = this.props;
        const {editWall} = this.state;

        return (
            <div>
                <Modal
                    open={isOpen}
                    onClose={toggler}
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    BackdropComponent={Backdrop}
                    BackdropProps={{ timeout: 500}}>
                    <Fade in={isOpen}>
                        <div className={classes.paper}>
                            <WallStepper dismiss={toggler} editWall={editWall}/>
                        </div>
                    </Fade>
                </Modal>
            </div>

        );
    }
}
const mapProps = (app:any) => ({walls: app.rootReducer.walls});

export default connect(mapProps, null)(withStyles(styles)(ModalWall));